import { apiClient } from './axios';

import type {
  ChatbotTool,
  ChatbotToolImportDto,
  ChatbotToolQuery,
  CreateChatbotToolDto,
  TestChatbotToolDto,
  TestChatbotToolResponse,
  UpdateChatbotToolDto,
} from '@repo/shared-types';

export const chatbotToolsApi = {
  getAll: async (query?: ChatbotToolQuery) => {
    const res = await apiClient.get<ChatbotTool[]>('/chatbot-tools', { params: query });
    return res.data;
  },
  getOne: async (id: string) => {
    const res = await apiClient.get<ChatbotTool>(`/chatbot-tools/${id}`);
    return res.data;
  },
  create: async (data: CreateChatbotToolDto) => {
    const res = await apiClient.post<ChatbotTool>('/chatbot-tools', data);
    return res.data;
  },
  update: async (id: string, data: UpdateChatbotToolDto) => {
    const res = await apiClient.patch<ChatbotTool>(`/chatbot-tools/${id}`, data);
    return res.data;
  },
  remove: async (id: string) => {
    await apiClient.delete(`/chatbot-tools/${id}`);
  },
  test: async (data: TestChatbotToolDto) => {
    const res = await apiClient.post<TestChatbotToolResponse>('/chatbot-tools/test', data);
    return res.data;
  },
  export: async (ids?: string[]) => {
    const res = await apiClient.post<{ tools: Record<string, unknown>[] }>(
      '/chatbot-tools/export',
      {
        ids,
      },
    );
    return res.data;
  },
  import: async (data: ChatbotToolImportDto) => {
    const res = await apiClient.post<{ created: number; updated: number }>(
      '/chatbot-tools/import',
      data,
    );
    return res.data;
  },
};
